import React, { useEffect, useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Trophy, Star, Clock, ArrowRight, ShieldCheck, Zap } from 'lucide-react';
export function PricingSection() {
  const [selected, setSelected] = useState<'combo' | 'base'>('combo');
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 45,
    seconds: 0
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) return {
          ...prev,
          seconds: prev.seconds - 1
        };
        if (prev.minutes > 0) return {
          ...prev,
          minutes: prev.minutes - 1,
          seconds: 59
        };
        if (prev.hours > 0) return {
          ...prev,
          hours: prev.hours - 1,
          minutes: 59,
          seconds: 59
        };
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="py-12 md:py-16 px-4 bg-slate-950 border-t border-slate-800/50" id="pricing" aria-labelledby="pricing-heading" data-id="element-184">
      <div className="max-w-2xl mx-auto" data-id="element-185">
        {/* Countdown Header */}
        <FadeIn className="text-center mb-8" data-id="element-186">
          <div className="inline-flex items-center justify-center gap-2 bg-red-500/10 text-red-500 border border-red-500/20 px-6 py-3 rounded-full mb-6" data-id="element-187">
            <Clock className="w-5 h-5" data-id="element-188" />
            <span className="font-bold tracking-wide" data-id="element-189">
              PRECIO DE LANZAMIENTO — CIERRA EN:
            </span>
            <span className="font-mono font-black text-lg ml-2" data-id="element-190">
              {String(timeLeft.hours).padStart(2, '0')}:
              {String(timeLeft.minutes).padStart(2, '0')}:
              {String(timeLeft.seconds).padStart(2, '0')}
            </span>
          </div>
          <p className="text-orange-500 font-bold mb-8" data-id="element-191">
            ⚠️ Después sube $8.000 ARS. No vuelve.
          </p>

          <h2 id="pricing-heading" className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-192">
            💳 ELEGÍ TU PACK
          </h2>
          <p className="text-slate-400 mb-2" data-id="element-193">
            Cupos al precio de lanzamiento — Quedan pocos
          </p>
          <div className="w-full max-w-xs mx-auto bg-slate-800 rounded-full h-2 mb-2" data-id="element-194">
            <div className="bg-orange-500 h-2 rounded-full" style={{
            width: '68%'
          }} data-id="element-195"></div>
          </div>
          <p className="text-xs text-slate-500" data-id="element-196">
            68% de los cupos al precio de lanzamiento ya tomados
          </p>
        </FadeIn>

        {/* Selection Cards */}
        <FadeIn delay={0.1} data-id="element-197">
          <div id="pricing-cards" className="space-y-4 mb-8 scroll-mt-16" data-id="element-198">
            {/* Combo Pro — Premium recommended card */}
            <div className="relative pt-3" data-id="element-199">
              {/* Floating "Recomendado" ribbon */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 z-10 flex items-center gap-1.5 bg-orange-500 text-white text-[10px] md:text-xs font-black tracking-widest uppercase px-4 py-1.5 rounded-full shadow-lg shadow-orange-500/40" data-id="element-200">
                <Star size={12} fill="currentColor" aria-hidden="true" data-id="element-201" />
                El más elegido
              </div>

              <button onClick={() => setSelected('combo')} aria-pressed={selected === 'combo'} aria-label="Seleccionar Sistema Humedad Cero + Pasaporte del Maestro por $27.990" className={`relative w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 overflow-hidden ${selected === 'combo' ? 'border-orange-500 bg-[#1A365D] shadow-[0_0_40px_rgba(221,107,32,0.15)]' : 'border-slate-800 bg-slate-900/50 opacity-80 hover:opacity-100'}`} data-id="element-202">
                {selected === 'combo' && <div aria-hidden="true" className="absolute -top-20 -right-20 w-40 h-40 bg-orange-500/10 rounded-full blur-3xl pointer-events-none" data-id="element-203" />}

                <div className="relative flex items-start gap-4" data-id="element-204">
                  <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 mt-1 flex items-center justify-center transition-colors ${selected === 'combo' ? 'border-orange-500 bg-orange-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-205">
                    {selected === 'combo' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-206" />}
                  </div>

                  <div className="flex-grow" data-id="element-207">
                    <div className="flex items-center justify-between flex-wrap gap-2 mb-3" data-id="element-208">
                      <div className="flex items-center gap-2" data-id="element-209">
                        <Trophy className="w-5 h-5 text-orange-500" data-id="element-210" />
                        <span className="text-xl font-black text-white tracking-wide" data-id="element-211">
                          SISTEMA + PASAPORTE
                        </span>
                      </div>
                      <div className="text-right" data-id="element-212">
                        <span className="text-slate-500 line-through text-sm mr-2" data-id="element-213">
                          $74.500
                        </span>
                        <span className="text-2xl font-black text-orange-400" data-id="element-214">
                          $27.990
                        </span>
                      </div>
                    </div>

                    <p className="text-white font-bold mb-1" data-id="element-215">
                      SISTEMA HUMEDAD CERO + PASAPORTE DEL MAESTRO
                    </p>

                    <p className="text-slate-300 text-sm mb-3" data-id="element-216">
                      4 Módulos + 3 Bonos + Kit de Implementación Completo
                    </p>

                    <p className="text-slate-400 text-xs italic" data-id="element-217">
                      Para ejecutar sin errores: Calculadora, Diario de Obra 21
                      días y Protocolo de Emergencia.
                    </p>
                  </div>
                </div>
              </button>
            </div>

            {/* Pack Base */}
            <button onClick={() => setSelected('base')} aria-pressed={selected === 'base'} aria-label="Seleccionar Sistema Humedad Cero + 3 Bonos por $19.990" className={`w-full text-left rounded-2xl p-6 border-2 transition-all duration-300 ${selected === 'base' ? 'border-green-500 bg-slate-900 shadow-[0_0_20px_rgba(34,197,94,0.1)]' : 'border-slate-800 bg-slate-900/50 opacity-70'}`} data-id="element-218">
              <div className="flex items-center gap-4" data-id="element-219">
                <div className={`w-6 h-6 rounded-full border-2 flex-shrink-0 flex items-center justify-center ${selected === 'base' ? 'border-green-500 bg-green-500' : 'border-slate-600'}`} aria-hidden="true" data-id="element-220">
                  {selected === 'base' && <div className="w-2.5 h-2.5 rounded-full bg-white" data-id="element-221" />}
                </div>

                <div className="flex-grow" data-id="element-222">
                  <div className="flex items-center justify-between flex-wrap gap-2 mb-2" data-id="element-223">
                    <div data-id="element-224">
                      <div className="flex items-center gap-2 mb-1" data-id="element-225">
                        <span className="text-blue-400" data-id="element-226">📘</span>
                        <span className="text-xl font-bold text-white" data-id="element-227">
                          SISTEMA BASE
                        </span>
                      </div>
                    </div>
                    <div className="text-right" data-id="element-228">
                      <span className="text-slate-500 line-through text-sm mr-2" data-id="element-229">
                        $43.940
                      </span>
                      <span className="text-2xl font-bold text-green-500" data-id="element-230">
                        $19.990
                      </span>
                    </div>
                  </div>
                  <p className="text-slate-300 font-medium mb-1" data-id="element-231">
                    SISTEMA HUMEDAD CERO + 3 BONOS
                  </p>
                  <p className="text-slate-400 text-sm mb-3" data-id="element-232">
                    Para empezar con sistema · 4 Módulos + 3 Bonos
                  </p>
                  <p className="text-slate-500 text-xs italic" data-id="element-233">
                    Para resolver la humedad paso a paso, sin pagar empresas.
                  </p>
                </div>
              </div>
            </button>
          </div>
        </FadeIn>

        {/* Main CTA Button */}
        <FadeIn delay={0.2} data-id="element-234">
          <a id="pricing-cta" href={selected === 'combo' ? 'https://fegion.shop/cart/47023822274699:1' : 'https://fegion.shop/cart/47023816179851:1'} target="_blank" rel="noopener noreferrer" className="group relative w-full flex flex-col items-center justify-center py-5 px-6 rounded-2xl bg-gradient-to-b from-green-500 to-green-600 hover:from-green-400 hover:to-green-500 text-white font-black transition-all shadow-[0_10px_30px_rgba(34,197,94,0.35)] hover:shadow-[0_15px_40px_rgba(34,197,94,0.5)] hover:scale-[1.02] active:scale-[0.99] overflow-hidden" aria-label={`Comprar ${selected === 'combo' ? 'Sistema + Pasaporte por $27.990' : 'Sistema Base por $19.990'}`} data-id="element-235">
            {/* Shimmer effect */}
            <span aria-hidden="true" className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-1000 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-236" />

            <span className="relative flex items-center justify-center gap-3 text-xl md:text-2xl" data-id="element-237">
              <span aria-hidden="true" className="text-2xl" data-id="element-238">
                💧
              </span>
              {selected === 'combo' ? 'QUIERO EL SISTEMA COMPLETO' : 'QUIERO MI SISTEMA AHORA'}
              <ArrowRight size={22} className="group-hover:translate-x-1 transition-transform" aria-hidden="true" data-id="element-239" />
            </span>
            <span className="relative text-xs font-medium text-green-50/90 mt-1.5 tracking-wide" data-id="element-240">
              Acceso inmediato · Garantía 30 días
            </span>
          </a>

          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs text-slate-500 mt-3" data-id="element-241">
            <span className="flex items-center gap-1" data-id="element-242">
              <ShieldCheck size={14} className="text-green-500" aria-hidden="true" data-id="element-243" />
              Pago seguro
            </span>
            <span className="text-slate-700" data-id="element-244">·</span>
            <span className="flex items-center gap-1" data-id="element-245">
              <Zap size={14} className="text-orange-500" aria-hidden="true" data-id="element-246" />
              Recibís todo en 5 minutos
            </span>
          </div>
        </FadeIn>
      </div>
    </section>;
}